export default __webpack_public_path__ + "static/media/doctor-2.1aee0723.PNG";